// export const API="https://maneemfi.com/";
export const API="https://gomanee.com/";

// export const API="http://192.168.99.225:8080";